'use client';

import { cache, useState } from 'react';
import useBackend from '@/backend';
import { useCasinoStoreActions } from '@/store';

/* --------------------------------- OPTIONS -------------------------------- */
const defaultHeaders = { 'Content-Type': 'application/json' } as const;
const route = '/casino/get-category-all-games';

/* -------------------------------------------------------------------------- */

export const useGetCategoryAllGames = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const { url, getAccessToken } = useBackend();
	const { setCasinoGamesWithCategories } = useCasinoStoreActions();

	const getCategoryAllGames = cache(async () => {
		setLoading(true);
		setError(null);

		try {
			const apiUrl = `${url}${route}`;
			const token = await getAccessToken({});
			const headers: HeadersInit = {
				...defaultHeaders,
				...(token ? { Authorization: token } : {}),
			};

			const response = await fetch(apiUrl, {
				method: 'GET',
				headers,
			});

			const data = await response.json();
			const gamesByCategory = (data?.data ?? []).map((category: any) => {
				if (category?.category?.name?.EN === 'Otherworld Originals') {
					return {
						...category,
						games: {
							...category.games,
							rows: [...category.games.rows].sort((a, b) => {
								return (b.isPlayable ? 1 : 0) - (a.isPlayable ? 1 : 0);
							}),
						},
					};
				}
				return category;
			});

			setCasinoGamesWithCategories(gamesByCategory);

			return { gamesByCategory, error: null };
		} catch (e: unknown) {
			const message = e instanceof Error ? e.message : 'Unknown error';
			setError(message);
			return { gamesByCategory: null, error: message };
		} finally {
			setLoading(false);
		}
	});

	return {
		loading,
		error,
		getCategoryAllGames,
	};
};

// 'use client';

// import { cache, useState } from 'react';
// import useBackend from '@/backend';
// import { useCasinoStoreActions } from '@/store';

// /* --------------------------------- OPTIONS -------------------------------- */
// const headers: { 'Content-Type': string; Authorization?: string } = {
// 	'Content-Type': 'application/json',
// };

// const route = '/casino/get-category-all-games';

// /* -------------------------------------------------------------------------- */

// export const useGetCategoryAllGames = () => {
// 	const [loading, setLoading] = useState(false);
// 	const [error, setError] = useState<string | null>(null);
// 	const { url, getAccessToken } = useBackend();
// 	const { setCasinoGamesWithCategories } = useCasinoStoreActions();

// 	/* -------------------------------------------------------------------------- */

// 	/* -------------------------------------------------------------------------- */

// 	const getCategoryAllGames = cache(async () => {
// 		try {
// 			setLoading(true);
// 			setError(null);
// 			const apiUrl = `${url}${route}`;
// 			const token = await getAccessToken({});

// 			if (token) headers.Authorization = token;

// 			const response = await fetch(apiUrl, {
// 				method: 'GET',
// 				headers,
// 			});

// 			/* -------------------------------------------------------------------------- */
// 			/* -------------------------------------------------------------------------- */
// 			const data = await response.json();

// 			const gamesByCategory = data?.data;

// 			/* -------------------------------------------------------------------------- */

// 			/* -------------------------------------------------------------------------- */

// 			setCasinoGamesWithCategories(gamesByCategory);

// 			return { gamesByCategory: gamesByCategory, error: null };
// 			/* -------------------------------------------------------------------------- */
// 		} catch (e: unknown) {
// 			const message = e instanceof Error ? e.message : 'Unknown error';
// 			setError(message);
// 			if (e instanceof Error) return { user: null, error: e.message };

// 			return { gamesByCategory: null, error: 'Failed to load user data' };
// 		} finally {
// 			setLoading(false);
// 		}
// 	});
// 	return {
// 		loading,
// 		error,
// 		getCategoryAllGames,
// 	};
// };
